import React, { Component } from 'react';

import {
    Container,
    Row,
    Col,
    FormGroup, Label, Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';



import ListBuilder from './listBuilder';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../helpers/linkHelper';
import { API_ENDPOINT, GOOGLE_API_KEY } from '../constants';
import moment from 'moment';
import eRemissIcon from '../assets/svg/e.svg';
import conditionLinkIcon from '../assets/svg/conditional-link-icon.svg'
import viewIcon from '../assets/svg/eye.svg'

import garabage from '../assets/svg/garbage.svg'
import DeleteModal from '../components/deleteModal';
import ErrorModal from '../components/errorModal';


import Isvg from 'react-inlinesvg';
import Checkbox from '../components/forms/fields/checkbox';


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


function truncateString(str, maxLength = 100) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    if (str.length > maxLength) {
        return str.substring(0, maxLength) + '...';
    }
    return str;
}




class ConditionLinksComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {

            conditionalLinks: []

        };
    }


    componentDidMount() {
        this.fetchConditionalLinks();



    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = this.props.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }

    fetchConditionalLinks = () => {
        const groupData = this.getGroupData();
        const isConditionalLinksEnabled = groupData?.conditionalLinks ? true : false;
        const groupId = this.props.selectedGroup;
        if (isConditionalLinksEnabled && groupId) {

            fetch(API_ENDPOINT + '/data/conditional-links/data/fetch', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ groupId: groupId })
            }).then(parseJSON).then(({ result, status }) => {
                let conditionalLinks = result?.items ?? [];
                this.setState({ conditionalLinks })
            })
        }

    }
    updateConditionalLinks = () => {
        const data = this.props.data;
        const conditionalLinks = data?.conditionalLinks ?? {};
        const groupId = this.props.selectedGroup;
        const patientId = data?._id;

        let obj = {
            groupId: groupId,
            patientId: patientId,
            conditionalLinks: conditionalLinks?.[groupId] ?? []
        }

        this.props.setLoading(true, () => {
            fetch(API_ENDPOINT + '/data/conditional-links/update/patient', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(parseJSON).then(({ result, status }) => {
                let setObj = {};
                this.props.setLoading(false);
                if (result?.error) {
                    this.props.setError(result.error);
                } else {
                    this.toggle(true);
                }

                if (Object.keys(setObj).length) {
                    this.setState(setObj);
                }
            })
        })






    }
    toggle = (refetch = false, callback) => {
        if (this.props.toggle) {
            this.props.toggle(refetch, callback);
        }
    }
    getPatientName = (data) => {
        let response = '';

        let patientName = data?.userData?.name;
        let parents = [];
        if (data?.parentObj?.name) {
            parents.push(data?.parentObj?.name)
        }
        if (data?.parentObj2?.name) {
            parents.push(data?.parentObj2?.name)
        }
        if (!parents?.length) {
            response = patientName;
        } else {
            response = parents?.join(` ${'and'.translate(this.props.lang)} `)
        }

        return response;
    }
    render() {
        const { isOpen, data } = this.props;

        const groupId = this.props.selectedGroup;


        const conditionalLinks = this.state.conditionalLinks ?? [];
        const conditionalLinksDict = {};
        for (let i = 0; i < conditionalLinks.length; i++) {
            const item = conditionalLinks[i];
            if (item.groupId == groupId) {
                conditionalLinksDict[item._id] = item.name;
            }
        }

        const title = this.getPatientName(data);


        return (
            <Modal isOpen={isOpen} centered className='conditional-links-component-modal-wrap'>
                <ModalHeader toggle={() => this.toggle()} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}>
                    <h4>{'Custom patient content'.translate(this.props.lang)}</h4>
                </ModalHeader>
                <ModalBody>
                    <div className='conditional-links-content-header-wrap'>
                        {title}
                    </div>
                    <div className='doctor-list-component-wrap'>
                        {conditionalLinks.length ? conditionalLinks.map((item, idx) => {
                            const userConditionalLinks = data?.conditionalLinks?.[groupId] ?? [];
                            const selected = userConditionalLinks.indexOf(item._id) !== -1 ? true : false;
                            return (
                                <div
                                    key={idx}
                                    className={selected ? 'colleague-item-wrap selected-item' : 'colleague-item-wrap'}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        let conditionalLinkModal = data;
                                        if (!conditionalLinkModal?.conditionalLinks) {
                                            conditionalLinkModal.conditionalLinks = {};
                                        }
                                        if (!conditionalLinkModal.conditionalLinks[groupId]) {
                                            conditionalLinkModal.conditionalLinks[groupId] = [];
                                        }
                                        const selectedId = item._id;

                                        let idx = conditionalLinkModal.conditionalLinks[groupId].indexOf(selectedId);
                                        if (idx == -1) {
                                            conditionalLinkModal.conditionalLinks[groupId].push(selectedId);
                                        } else {
                                            conditionalLinkModal.conditionalLinks[groupId].splice(idx, 1);
                                        }
                                        this.setState({ data: conditionalLinkModal })
                                    }}
                                >
                                    <div className='colleague-data-wrap'>

                                        <div className='colleague-name-wrap'>
                                            <div className='colleague-name'>{item.name}</div>
                                            <div className='colleague-username' style={{ paddingLeft: 10, fontSize: 11 }}>
                                                {
                                                    item?.arrayOfAllowedLinks?.map((link, index) => {
                                                        return (
                                                            <div>
                                                                {link?.buttonText ? link.buttonText + ' - ' : ''}<span style={{ fontStyle: 'italic' }}>{truncateString(link?.link, 40)}</span>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    <div>
                                        <Checkbox
                                            // disabled={false}
                                            checked={selected}
                                            onChange={(e) => {
                                                return;
                                            }}
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                            )
                        })
                            :
                            <div>
                                {'There are no custom patient content added yet.'.translate(this.props.lang)} {'Please go to the'.translate(this.props.lang)} <a onClick={() => this.props?.[0].history?.push('/my-data/conditional-links')} style={{ color: '#007bff', cursor: 'pointer' }}>{'Custom patient content page'.translate(this.props.lang)}</a> {'and add them'.translate(this.props.lang)}.
                            </div>
                        }
                    </div>

                </ModalBody>
                <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: "flex-end" }}>
                    <Button color="primary" disabled={this.props.loading} onClick={() => this.updateConditionalLinks()}>{'Save'.translate(this.props.lang)}</Button>
                    <Button color="primary" onClick={() => this.toggle()}>{'Close'.translate(this.props.lang)}</Button>
                </ModalFooter>
            </Modal>
        );


    }
}
export default ConditionLinksComponent;